import {ApiDealerXClient} from '@dealer-group/dealer-api-clients'

export function storeTemporaryToken(payload) {
    return ApiDealerXClient.post('/leads/integrations/facebook/temporary-token', payload);
}
